import store from "../index";
import {VuexModule, Module, Mutation, Action} from "vuex-class-modules";
import tablet from "@/services/da/tablets.service";
import screenshots from "@/services/da/tablet-screenshots.service";
import {DocumentSnapshot, Timestamp, Unsubscribe} from "firebase/firestore";
import {ref} from "vue";

@Module
class TabletPageModule extends VuexModule
{

    data: any = null;

    screenshots: any[] = [];

    locked = false

    @Action
    async load(id: string)
    {
        this.busy(true)

        const snapshot = await tablet.getById(id);
        if (snapshot.exists()) {
            this.update(snapshot.data());
        }
        this.busy(false)
    }

    @Action
    async loadScreenshots(arg: {size: number, beforeTheTime: Timestamp | number, afterTheTime: Timestamp | number, lastSeen: DocumentSnapshot | null;})
    {
        this.busy(true)

        const {Id} = this.data;
        const {size, beforeTheTime, afterTheTime, lastSeen} = arg;

        const list = await (new Promise(
            resolve => screenshots.getByDeviceId(Id, size, lastSeen,
                beforeTheTime, afterTheTime, (d: any) => resolve(d)))) as any[];
        this.updateScreenshots(list);

        this.busy(false)
    }

    @Action
    preloadLatestScreenshots(size: number)
    {
        this.busy(true)

        const {Id} = this.data;
        const afterTheTime = ref(new Date).value.getTime();
        const $query = screenshots.getQueryByDevice(Id, size, null,
            0, afterTheTime);

        const maxTimeout = setTimeout(() => {
            if (onSnapshotUpdate != undefined) {
                onSnapshotUpdate()
            }
        }, 60 * 1000)

        let onSnapshotUpdate: Unsubscribe|undefined = undefined;

        const callback = () => {
            if (onSnapshotUpdate != undefined) {
                onSnapshotUpdate()
            }
            clearTimeout(maxTimeout)
            this.busy(false)
        }

        onSnapshotUpdate = screenshots.getSnaphostCollectionByQuery($query, snapshot =>
        {
            if (!snapshot.empty) {
                screenshots.preRender(snapshot)
                .then(collection => {
                    this.unshiftScreenshots(collection)
                }).finally(() => callback());
            }
        }, (error) => {
            callback()
            console.error(error)
        }, () => callback());
    }

    @Mutation
    update(data: any)
    {
        this.data = data;
    }

    @Mutation
    updateScreenshots(screenshot: any[])
    {
        this.screenshots = screenshot;
    }

    @Mutation
    unshiftScreenshots(collection: any)
    {
        console.log('unshiftScreenshots ', collection, Array.isArray(collection))
        this.screenshots.unshift(...collection);
    }

    @Mutation
    busy(isBusy: boolean)
    {
        this.locked = isBusy;
    }

    @Action
    reset()
    {
        this.resetStates();
    }

    @Mutation
    resetStates()
    {
        this.data = null;
    }
}
const name = "tabletPageModule";

export const tabletPageModule = new TabletPageModule({
    store,
    name
});
